import styled from 'styled-components';

import { Button } from '@components/form';
import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { typography } from '@theme/font';
import { ALIGN, DIRECTION, flex } from '@theme/helpers';

export const InnerContainer = styled(Button).attrs({ type: 'button' })`
  ${typography({})};
  ${flex({ direction: DIRECTION.REVERSE })}
  background-color: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  width: 100%;
  text-transform: uppercase;
  position: relative;
  padding: 12px 16px 12px;
  height: 44px;

  ${media.tablet} {
    height: auto;
    min-height: 35px;
    flex-direction: row;
    padding: 8px 12px 6px;
    background-color: transparent;
    justify-content: space-between;
    color: ${COLORS.BLACK};
  }
`;

export const OuterContainer = styled.div`
  ${flex({ align: ALIGN.UNSET })}
  width: 100%;
  position: relative;
`;

export const Text = styled.span<{ added: boolean }>`
  position: relative;
  white-space: nowrap;

  &:before {
    content: '✓';
    margin-right: 8px;
    display: ${({ added }) => (added ? 'inline-block' : 'none')};
  }
`;

export const MobileCopy = styled.span`
  display: inline;
  margin-left: 10px;

  ${media.tablet} {
    display: none;
  }
`;

export const DesktopCopy = styled.span`
  display: none;

  ${media.tablet} {
    display: inline;
  }
`;

export const Price = styled.span`
  margin-right: 10px;

  ${media.tablet} {
    margin: 0;
  }
`;
